import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StreamEntrypointMonitoringQuery } from "../graphql/queries";
import type {
  StreamEntrypointMonitoringQueryType,
  StreamEntrypointMonitoringQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStreamEntrypointMonitoringQuery = (
  options?: QueryHookOptions<
    StreamEntrypointMonitoringQueryType,
    StreamEntrypointMonitoringQueryVariablesType
  >
) =>
  useQuery<
    StreamEntrypointMonitoringQueryType,
    StreamEntrypointMonitoringQueryVariablesType
  >(StreamEntrypointMonitoringQuery, options);
